// eslint-disable-next-line import/prefer-default-export
export const parse = (jwt) => {
  const jsonString = atob(jwt, 'base64');
  if (!jsonString) return null;
  // Step 2: Parse the JSON string to get the original object
  const payload = JSON.parse(jsonString);
  if (!payload) return null;
  const { token, meta = {}, type } = payload;
  return {
    sessionId: token,
    meta,
    type,
  };
};
